import isPresent from "../validation/isPresent";

export type SamplingStorage = Pick<Storage, "getItem" | "setItem">;

type IsSessionSampledOptions = {
  storage: SamplingStorage;
  sampleRate: number;
  random?: () => number;
};

const SAMPLING_STORAGE_KEY = "telemetry:isSessionReplaySampled";

export function isSessionSampled({
  storage,
  sampleRate,
  random = Math.random,
}: IsSessionSampledOptions) {
  const stored = storage.getItem(SAMPLING_STORAGE_KEY);

  if (isPresent(stored)) {
    return stored === "true";
  }

  const isSampled = random() < sampleRate;
  storage.setItem(SAMPLING_STORAGE_KEY, String(isSampled));
  return isSampled;
}
